module.exports = __webpack_public_path__ + "media/images/brand/original/MARQUESBRANDINGCO LOGO ORIGINAL X-a7d5e9b254036e9822de3e7be0cf9b34.png";